import { Dialog, Box, CircularProgress } from '@mui/material';

import DialogTip from './DialogTip';
import DialogStepOne from './DialogStepOne';
import DialogStepTwo from './DialogStepTwo';
import DialogStepLast from './DialogStepLast';
import DialogFeedback from './DialogFeedback';

function MainDialog(props) {
  const { open, loading, step, classes, mediaQuery, closeDialog } = props;

  const renderDialogContent = () => {
    const dialogProps = { closeDialog };
    switch (step) {
      case 1: {
        return <DialogStepOne {...dialogProps} />;
      }

      case 2: {
        return <DialogStepTwo {...dialogProps} />;
      }

      case 3: {
        return <DialogStepLast {...dialogProps} />;
      }

      case 4: {
        return <DialogFeedback {...dialogProps} />;
      }

      case 5: {
        return <DialogTip {...dialogProps} />;
      }

      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => closeDialog()}
      maxWidth="md"
      fullScreen={mediaQuery.isMobile}
      disableEscapeKeyDown
      sx={classes.container}
      fullWidth
      slotProps={{
        paper: {
          sx: { padding: '16px 0', ...classes.container, ...classes.dialogPaper },
        },
      }}
    >
      {loading && (
        <Box sx={classes.dialogOverlay}>
          <CircularProgress sx={classes.dialogOverlayProgress} color="primary" />
        </Box>
      )}
      {renderDialogContent()}
    </Dialog>
  );
}

export default MainDialog;
